'use strict';

var _ = require('lodash');
var angular = require('angular');
var RefreshedDataTooltipFactory = function RefreshedDataTooltipFactory() {
  var HIDE_DELAY = 50;
  function RefreshedDataTooltip() {}
  RefreshedDataTooltip.constructor = RefreshedDataTooltip;
  function renderValue(rendererName, value) {
    if (rendererName === 'percentageRender' && value !== '') {
      return Math.round(value * 10000) / 100;
    }
    return value;
  }
  function getHtmlContent(cellData) {
    var valueChange = cellData.value - cellData.valueBeforeRefresh;
    var tooltipData = {
      currentValue: cellData.value,
      prevValue: cellData.valueBeforeRefresh,
      change: valueChange
    };
    for (var prop in tooltipData) {
      if (!_.isEmpty(cellData.valueformat)) {
        tooltipData[prop] = angular.element.jqx.dataFormat.formatnumber(tooltipData[prop], cellData.valueformat);
      } else if (!_.isEmpty(cellData.rendererName)) {
        tooltipData[prop] = renderValue(cellData.rendererName, tooltipData[prop]);
      }
    }
    tooltipData.change = valueChange > 0 ? '+' + tooltipData.change : tooltipData.change;
    tooltipData.increased = valueChange > 0;
    var tooltipContent = _.template(require('../templates/refreshed-data-tooltip.html'));
    return tooltipContent(tooltipData);
  }
  RefreshedDataTooltip.prototype.getBuilder = function () {
    return function (cellData, wholeGridData) {
      if (cellData.value || cellData.value === 0) {
        return {
          htmlContent: getHtmlContent(cellData, wholeGridData),
          hideDelay: HIDE_DELAY,
          placement: 'top'
        };
      } else {
        return '';
      }
    };
  };
  return RefreshedDataTooltip;
};
module.exports = RefreshedDataTooltipFactory;